import AltBankLogo from "../AltbankLogo";
import CbnFooter from "../CbnFooter";
import Stepper, { StepperProps } from "../Stepper";
import styles from "./styles.module.css";
interface ProcessLayoutProps {
  children: React.ReactNode;
  stepperProps: StepperProps;
}
const ProcessLayout: React.FC<Partial<ProcessLayoutProps>> = ({
  stepperProps,
  children,
}) => {
  return (
    <div className={styles.layoutWrapper}>
      <div className={styles.layoutTop}>
        <div className={styles.logoWrapper}>
          <AltBankLogo colored />
        </div>
        <div className={styles.stepperWrapper}>
          <Stepper {...stepperProps} />
        </div>
      </div>
      <div className={styles.layoutContent}>{children}</div>
      <div className={styles.footerWrapper}>
        <CbnFooter />
      </div>
    </div>
  );
};

export default ProcessLayout;
